/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from 'firebase/app';
import { catchError, map } from 'rxjs/operators';

import { URL_ASSETS } from 'src/app/shared/const';
import { resourcesImages } from 'src/app/shared/const/images-resources';
import { UpdateAdminDto } from 'src/app/shared/dto/admin/update-admin.dto';
import { FirebaseProvider } from 'src/app/shared/enums/firebaseProvider';
import { UpdateAdminGQL } from 'src/app/shared/graphql';
import { AlertService, AuthService, ProblemsInterceptorService, ThememodeService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
import { routesV3 } from '../shared/const/routes-config';
import { TelemetryService } from '../shared/services/telemetry.service';

@Component({
  selector: 'app-login-v3',
  templateUrl: './login-v3.component.html',
  styleUrls: ['./login-v3.component.scss']
})
export class LoginV3Component implements OnInit, AfterViewInit {
  submited = false;
  loading = false;
  googleSubmited = false;
  microsoftSubmited = false;
  classLinkSubmited = false;
  cleverSubmited = false;
  isLight!: boolean;
  userUrl = environment.userPortalURL;
  resources!: Array<any>;
  districtId!: string;
  isClassLinkAccess!: boolean;
  isCleverAccess!:boolean;
  tokenParam!: string;
  showCleverAuth = environment.showCleverAuth;
  isEmptyProviderCredentials!:boolean;
  isLinkingRedirect!: boolean;
  params!: any;
  

  constructor(private authService: AuthService, private afAuth: AngularFireAuth, private activatedRoute: ActivatedRoute,
    private thememodeService: ThememodeService, private router: Router, private domSanitizer: DomSanitizer,
    private updateAdminGQL: UpdateAdminGQL, private problemInterceptor: ProblemsInterceptorService,
     private telemetryService: TelemetryService, private alertService: AlertService) {
    this.thememodeService.load('v2');
    this.isLight = this.thememodeService.getColorScheme() !== 'dark';
    this.resources = [
      !this.isLight ? this.domSanitizer.bypassSecurityTrustResourceUrl(URL_ASSETS + resourcesImages['cloud-vertical-white']) : this.domSanitizer.bypassSecurityTrustResourceUrl(URL_ASSETS + resourcesImages['cloud-vertical-fullcolor']),
      URL_ASSETS + resourcesImages['google-image'],
      URL_ASSETS + resourcesImages['microsoft-image'],
      URL_ASSETS + resourcesImages['classlink-light'],
      URL_ASSETS + resourcesImages['classlink-dark'],
      URL_ASSETS + resourcesImages['clever'],
      URL_ASSETS + resourcesImages['itopia-logo-dark'],
    ];
    this.params = this.activatedRoute?.snapshot?.queryParams;
    this.districtId = this.params?.districtId;


    const provider = this.params?.provider;
    this.isLinkingRedirect = this.params?.linking;

    this.classLinkSubmited = sessionStorage.getItem('classlinkAuth') === 'true';
    this.cleverSubmited = sessionStorage.getItem('cleverAuth')=== 'true';
    this.microsoftSubmited = sessionStorage.getItem('microsoftAuth')=== 'true';
    this.googleSubmited = sessionStorage.getItem('googleAuth')=== 'true';

    if( provider && provider === FirebaseProvider.Microsoft && this.isLinkingRedirect){
      this.removeQueryParam('provider');
      this.removeQueryParam('linking');    
      this.signInWithMicrosoft();      
    } else {
        if (provider && !this.classLinkSubmited) {
          this.sigInWithServerAuth(provider);
        }
    }
  }

  sigInWithServerAuth(provider: FirebaseProvider): void {
    switch (provider) {
      case FirebaseProvider.ClassLink:
        this.signInWithClassLink();
        break;
      default:
    }
  }

  ngAfterViewInit(): void {
    this.authService.deleteStItems();  
  }

  getCurrentFirebaseProvider(): FirebaseProvider | null {
      if (this.googleSubmited) {
        return FirebaseProvider.Google;
      }
      if (this.microsoftSubmited) {
        return FirebaseProvider.Microsoft;
      }
      if (this.classLinkSubmited) {
        return FirebaseProvider.ClassLink;
      }
      if (this.cleverSubmited) {
        return FirebaseProvider.Clever;
      }

      // Si ninguno está activo
      return null;
    }

  ngOnInit(): void { 
    this.loading = sessionStorage.getItem('signInRedirect') === "true";
    this.authService.loginFailed.subscribe((failed) => {
      if (failed) {
          this.clearLoading();
      }
    });
    this.afAuth.getRedirectResult().then((result: any): any => {
      this.loading = true;
      if (result.user) {
        return this.authService.setUserDataPromise(result.user).then((value: boolean): any => {
            const linked =  localStorage.getItem('linkedProvider');
            //linking with microsoft
              if(linked === FirebaseProvider.Microsoft.toString()){
                  localStorage.removeItem('linkedProvider');
                  this.signInWithMicrosoft();   
            } else {
                this.updateAdmin();
                    if (value) {           
                      sessionStorage.removeItem('signInRedirect');            
                      return this.router.navigate(['/']).then(()=>{
                         this.clearLoading(true, false, true);
                      });       
                   }

            }      
        })
      } else {
        if(!this.params?.linking){
          this.clearLoading();
        }       
      }
    }).catch((error: any) => {    
      if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
       void this.authService.fetchSignInMethodsForEmail(error, false, this.getCurrentFirebaseProvider());
      } else {
        this.authService.showErrorMessage(error);
        this.clearLoading();    
      }  
   
    });

    this.authService.existEmptyProvider.subscribe((provider: FirebaseProvider)=>{
      if(provider === FirebaseProvider.Microsoft){
          this.isEmptyProviderCredentials = true;
          this.clearLoading(false, true);
      }
    });
  }

  goToBackCredentials(): void {
    this.isEmptyProviderCredentials = false;    
    this.clearLoading();
  }

  updateAdmin(): void {
    this.updateAdminGQL.mutate()
      .pipe(
        map(({ data }) => {
          const result = data as UpdateAdminDto;
          if (result?.data?.updateAdmin?.problem) {
            this.problemInterceptor.intercept(result?.data?.updateAdmin?.problem);
          }
        }),
        catchError((error) => {
          this.problemInterceptor.interceptError(error);
          return error;
        })
      ).subscribe();
        const processId = this.telemetryService.generateProcessId();
      sessionStorage.setItem('processId', processId);
  }

  signIn(): void {
    this.googleSubmited = true;
     sessionStorage.setItem('googleAuth', 'true');
    if(!environment.authWithPopup){
      if(this.isEmptyProviderCredentials){
         localStorage.setItem('linkedProvider', FirebaseProvider.Microsoft.toString());
      }
      sessionStorage.setItem('signInRedirect', 'true');
      const provider = new firebase.auth.GoogleAuthProvider();
      this.loading = true;
      void this.authService.signInWithRedirect(provider);
    } else {
      this.sigInGooglePopup();    
    }
  }

  
  sigInGooglePopup(): void {
    try {
      const provider = new firebase.auth.GoogleAuthProvider();
      this.authService.authPopUp(provider).then((value) => {
        if(value){
          void this.redirectWithPopup();
        } else {
          this.clearLoading();

        } 
      }).catch(() => {
          this.clearLoading();
      });
    } catch (error) {
      this.clearLoading();
    }
  }

  signInMicrosoftPopup(): void {
    try {
      const provider = new firebase.auth.OAuthProvider(FirebaseProvider.Microsoft);
      this.authService.authPopUp(provider).then((value) => {
        if(value){
          void this.redirectWithPopup();
        } else {
           this.clearLoading();
        }      
      }).catch(() => {
         this.clearLoading();
      });
    } catch (error) {
       this.clearLoading();
    }
  }

  redirectWithPopup(): Promise<boolean> {
    this.updateAdmin();
    sessionStorage.setItem('v3', "true");
    const route = routesV3.cloudapps.children.checkrole.route;
     this.clearLoading(true, false, true);
    return this.router.navigate([route]);
  }

  signInWithClassLink(): void {
    if(this.isEmptyProviderCredentials){
      localStorage.setItem('linkedProvider', FirebaseProvider.Microsoft.toString());
    }
    this.classLinkSubmited = true;
    this.loading = true;
    sessionStorage.setItem('classlinkAuth', "true");
    sessionStorage.setItem('signInRedirect', 'true');
    const authorizationUrl = new URL(environment.classlinkAuthUrl);
    authorizationUrl.searchParams.set('client_id', environment.classlinkClientId);
    authorizationUrl.searchParams.set('redirect_uri', `${environment.apiURL}/__/auth/handler?login=admin`);
    authorizationUrl.searchParams.set('response_type', 'code');
    authorizationUrl.searchParams.set('scope', 'profile,oneroster,openid');

    // Request an Authorization Token
    window.location.replace(String(authorizationUrl));
  }

  signInWithClever(): void {
    if(!this.showCleverAuth){
      return;
    }
     if(this.isEmptyProviderCredentials){
      localStorage.setItem('linkedProvider', FirebaseProvider.Microsoft.toString());
    }
    this.cleverSubmited = true;
    this.loading = true;
    sessionStorage.setItem('signInRedirect', 'true');
    sessionStorage.setItem('cleverAuth', "true");
    const authorizationUrl = new URL(environment.cleverAuthUrl);
    authorizationUrl.searchParams.set('client_id', environment.cleverClientId);
    authorizationUrl.searchParams.set('response_type', 'code');
   // authorizationUrl.searchParams.set('scope', 'profile,oneroster,openid');
    authorizationUrl.searchParams.set('redirect_uri', `${environment.apiURL}/auth/clever?login=admin`);

    // Request an Authorization Token
    window.location.replace(String(authorizationUrl));
  }

  signInWithMicrosoft(): void {
    this.microsoftSubmited = true;
    if(!environment.authWithPopup){
      sessionStorage.setItem('microsoftAuth', "true");
      sessionStorage.setItem('signInRedirect', 'true');
      const provider = new firebase.auth.OAuthProvider(FirebaseProvider.Microsoft);
      this.loading = true;
      this.isLinkingRedirect = false;
      void this.authService.signInWithRedirect(provider);
    } else {
      this.signInMicrosoftPopup();
    }    
  }

  goToStudentPortal(): void {
     window.open(this.userUrl, '_blank');
  }

  clearLoading(loading?: boolean, linking?:boolean, persistAuth?: boolean): void {
      this.classLinkSubmited = false;
      this.cleverSubmited = false;
      this.microsoftSubmited = false;
      this.googleSubmited = false;
      if(!persistAuth) {
          sessionStorage.removeItem('classlinkAuth');
          sessionStorage.removeItem('cleverAuth');            
          sessionStorage.removeItem('googleAuth');
          sessionStorage.removeItem('microsoftAuth');
      }  
      this.isLinkingRedirect = false;
      if(!linking){
          localStorage.removeItem('linkedProvider');
      }            
      this.submited = false;
      this.loading = loading ?? false;      
  }

  removeQueryParam(paramName: string): void {
    const currentQueryParams = { ...this.activatedRoute.snapshot.queryParams };
    
    delete currentQueryParams[paramName];

    void this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: currentQueryParams,
      queryParamsHandling: '',
      replaceUrl: true 
    });
 }
}
